import type { FetchData, FetchState, Action } from '../types';
import { strategies } from './reducer-strategies';
import { initialState } from './state';

export const reducer = (state: FetchState<FetchData> = initialState, action: Action) => {
	// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
	const transformer = strategies[action.type] || strategies.default;
	return transformer(state, action);
};
